import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { getSession } from "../../../redux/actions/authActions";
import { PhoneIcon } from "../../../../assets/PhoneIcon";
import { LocationIcon } from "../../../../assets/LocationIcon";
import MenuIcon from "../../../../assets/MenuIcon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const FacilityCard = ({
  handleShow,
  data,
  handleEditModal,
  handleCalenderShow,
  handleCalenderOpen,
  handleVerifyFacility,
  route,
  isShowNext,
  patient,
}) => {
  const history = useHistory();
  const {
    svcf_user_profile_id,
    svcf_name,
    svcf_desc,
    svcf_contact_phone_nbr,
    svcf_id,
    svcf_photo,
    iso_city_name,
    iso_cntry_name,
    svcft_typ_desc,
    has_calendar_yn,
    svcf_addr_street1,
    calendar,
    services,
    svcf_verifier_notes_txt,
  } = data;

  const [showMore, setShowMore] = useState(false);
  const { role_id } = getSession();
  const shouldText = svcf_desc.length > 100;
  const displayText = showMore
    ? svcf_desc
    : `${svcf_desc.slice(0, 100)}${shouldText ? "..." : ""}`;

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const [showIcons, setShowIcons] = useState(false);
  const showBookSlotText =
    (role_id !== "4" || route === "addorder") &&
    window.location.pathname !== "/health/dashboard/facilities";

  const handleShowIcons = () => {
    setShowIcons(!showIcons);
  };

  const handleNext = () => {
    localStorage.setItem("timeSlots", JSON.stringify(calendar));
    history.push(`/dashboard/explore/services/${svcf_id}`);
  };

  return (
    <div className="h-full bg-white rounded-md border-[0.64px] border-[#E1E1E1]">
      <div className="h-[158px]">
        {svcf_photo && !svcf_photo.includes("undefined") ? (
          <img
            src={svcf_photo}
            alt="Facility"
            className="w-full h-full object-cover rounded-t-md"
          />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <div className="icon-text-container">
              <Icon
                icon="streamline-emojis:hospital"
                style={{ fontSize: "100px" }}
              />
              {role_id !== 5 && (
                <div className="text-below-icon">
                  Edit facility and Upload your logo or pic
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="p-3 h-[calc(100%-158px)]">
        <div className="flex flex-col justify-between h-full">
          <div className="relative">
            <span className="text-gray-500">#{svcf_id}</span>

            <h5 className="text-[#26262A] font-semibold text-lg flex gap-1 items-center">
              {svcf_name}
              {svcf_verifier_notes_txt && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Icon icon="ic:outline-verified-user" color="green" />
                </div>
              )}
            </h5>
            <p className="text-[14px] text-[#767676] font-normal leading-[19px]">
              {svcft_typ_desc}
            </p>
            <p className="text-[14px] text-[#767676] font-normal leading-[19px]">
              {displayText}
              {shouldText && (
                <span
                  className="text-primary-blue cursor-pointer"
                  onClick={toggleShowMore}
                >
                  {" "}
                  {showMore ? "Show Less" : "Show More"}
                </span>
              )}
            </p>
            <div className="flex gap-2">
              <div className="mt-1">
                <PhoneIcon />
              </div>
              <p className="text-[#767676]">+{svcf_contact_phone_nbr}</p>
            </div>

            <div className="flex gap-2">
              <div className="mt-1">
                <LocationIcon />
              </div>
              <p className="text-[#767676]">
                {svcf_addr_street1}, {iso_city_name}, {iso_cntry_name}
              </p>
            </div>
          </div>
          <div className="lo w-full ">
            {!isShowNext && showBookSlotText && (
              <div
                style={{
                  color: "#3b71ca",
                  cursor: "pointer",
                  fontWeight: "700",
                }}
              >
                <button
                  className="sign_btn add-order-btn"
                  style={{ fontSize: "12px", width: "200px" }}
                  onClick={() =>
                    handleCalenderOpen(
                      svcf_id,
                      calendar,
                      services,
                      svcf_user_profile_id
                    )
                  }
                >
                  SCHEDULE TIME SLOT
                </button>
              </div>
            )}

            {isShowNext && (
              <div
                style={{
                  color: "#3b71ca",
                  cursor: "pointer",
                  fontWeight: "700",
                }}
              >
                <button
                  className="sign_btn add-order-btn"
                  style={{ fontSize: "14px", width: "100%" }}
                  onClick={handleNext}
                >
                  Select this Provider
                </button>
              </div>
            )}
            <div className="flex justify-end relative">
              <div className="flex gap-3 w-full justify-between">
                {has_calendar_yn === "Y" ? (
                  <Link
                    to={
                      patient?.user_first_name
                        ? `/dashboard/explore/services/${svcf_id}?patient=${patient?.svcuser_profile_id}`
                        : `/dashboard/services/${svcf_id}`
                    }
                    className="w-full"
                  >
                    <button className="sign_btn !text-sm">+ Services</button>
                  </Link>
                ) : (
                  route === "facilities" && (
                    <button
                      className="sign_btn !text-sm"
                      onClick={handleCalenderShow}
                    >
                      + Calendar
                    </button>
                  )
                )}
                <div
                  className="border rounded-md w-[15%] flex justify-center items-center cursor-pointer"
                  onClick={handleShowIcons}
                >
                  {route === "facilities" && <MenuIcon />}
                </div>
              </div>
              <div
                className={`${
                  showIcons
                    ? "w-fit py-1 flex h-32 bg-white shadow-xl absolute bottom-12 border-red-500 border rounded-md"
                    : "hidden"
                }`}
              >
                <div className="flex flex-col !gap-3 !py-2 !px-3">
                  {role_id < 5 && (
                    <>
                      <div
                        className="flex gap-2 items-center cursor-pointer"
                        onClick={() => handleEditModal(data)}
                      >
                        <Icon
                          icon="fluent:edit-48-filled"
                          className="!text-red-600 !text-base"
                        />
                        <p className="m-0 !text-xs !text-[#262627] !font-normal">
                          Edit facility
                        </p>
                      </div>
                      <div
                        className="flex gap-2 items-center cursor-pointer"
                        onClick={handleShow}
                      >
                        <Icon
                          icon="mingcute:delete-fill"
                          className="!text-red-600 !text-base"
                        />
                        <p className="m-0 !text-xs !text-[#262627] !font-normal">
                          Delete facility
                        </p>
                      </div>
                      <div
                        className="flex gap-2 items-center cursor-pointer"
                        onClick={handleCalenderShow}
                      >
                        <Icon
                          icon="uil:calender"
                          className="!text-red-600 !text-base"
                        />
                        <p className="m-0 !text-xs !text-[#262627] !font-normal">
                          Facility Calendar
                        </p>
                      </div>
                      {role_id < 4 && (
                        <div
                          className="flex gap-2 items-center cursor-pointer"
                          onClick={() => handleVerifyFacility(data)}
                        >
                          <Icon
                            icon="tdesign:verified"
                            className="!text-red-600 !text-base"
                          />
                          <p className="m-0 !text-xs !text-[#262627] !font-normal">
                            Verify facility
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
